import gql from 'graphql-tag';

export default gql`
    mutation DeleteYard($input: DeleteYardInput) {
        deleteYard(input: $input) {
            errors
        }
    }
`;
